const  IsBeforeTargetVersion = (targetVersion, currentVersion= '') =>{
	if (!targetVersion || !currentVersion) {
		return false
	}

	if (targetVersion === currentVersion) {
		return false;
	}
	const version1Array = targetVersion.split(".");
	const version2Array = currentVersion.split(".");

	let index = 0;
	let minLen = Math.min(version1Array.length, version2Array.length);

	for (; index < minLen; index ++) {
		let server_int = parseInt(version1Array[index]);
		let local_int = parseInt(version2Array[index]);
		if (server_int > local_int) {
			return true
		} else if (server_int < local_int) {
			return false
		}
	}

	return version1Array.length > index
}

const GetAppVersion = () => {
	return window.appVersion ? window.appVersion : ''
}

const CheckVersionCompatible = (targetVersion, bridgeSDKClient) => {
	if (IsBeforeTargetVersion(targetVersion, GetAppVersion())) {
		bridgeSDKClient && bridgeSDKClient.incompatibleSDK && bridgeSDKClient.incompatibleSDK()
	}
}

export  {
	IsBeforeTargetVersion,
	CheckVersionCompatible,
	GetAppVersion
}
